/* istanbul ignore file */

export { OpenJobsPage as default } from "./OpenJobsPage";
